/**
 * Error403 - компонент помилки доступу
 */

import { Result } from 'antd'
import * as React from 'react'
import { useTranslation } from 'react-i18next'

export const Error403: React.FC = () => {
    const { t } = useTranslation()

    return (
        <Result
            status="403"
            title="403"
            subTitle={t('Sorry, you are not authorized to access this page.', { ns: 'Core' })}
        />
    )
}

export default Error403

